export default __webpack_public_path__ + "static/integration-animated-d06b98271c0bdb0a4d9feebca7107016.svg";